<template>
  <div>
    <Pane />
    <a-card class="container">
      <a-descriptions bordered :column="2" size='small'>
        <a-descriptions-item>
          <div slot="label" class="center">项目名称</div>
          <div>
            <ProjectSelector @change="onSelectProject">
                <a-button
                    block
                    style="text-align: left;width: 100%"
                >{{ selectedProject.name ? selectedProject.name : '选择' }}</a-button>
              </ProjectSelector>
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">公司</div>
          <div>
            <CompanySelector @change="(company) => (selectedCompany = company)">
              <a-button block style="text-align: left" class="ellipsis">
                <div
                  class="left text-hidden selected"
                  v-if="selectedCompany.name"
                >
                  {{ selectedCompany.name }}
                </div>
                <div class="left placeholder" v-else>请选择公司</div>
              </a-button>
            </CompanySelector>
          </div>
        </a-descriptions-item>
        <a-descriptions-item>
          <div slot="label" class="center">经办人</div>
          <div>
              <EmployeeSelector @change="(arr) => {
                                if (arr.length > 0) {
                                selectedUser = arr[0];
                                } else {
                                selectedUser = {};
                                }
                            }
                            " :value="selectedUser.name ? [selectedUser] : []">
                <a-button block style="text-align: left;width: 100%">
                <div v-if="selectedUser.name">
                    {{ selectedUser.name }}
                </div>
                <div v-else>&nbsp;</div>
                </a-button>
            </EmployeeSelector>
          </div>
        </a-descriptions-item>

        <a-descriptions-item>
          <div slot="label" class="center">发生金额(万)</div>
          <div>
            <a-input-number
                placeholder=""
                v-model="detail.amount"
                :min="0"
                style="width: 100%"
              />
          </div>
        </a-descriptions-item>

        <a-descriptions-item>
          <div slot="label" class="center">发生日期</div>
          <div>
            <a-date-picker
                v-model="detail.date"
                placeholder=""
                style="width: 100%"
              />
          </div>
        </a-descriptions-item>
      </a-descriptions>


      <div class="center" style="margin-top: 40px;">
        <a-space>
          <a-button @click="$close($route.path)">关闭</a-button>
          <a-button type="primary" @click="handleSubmit">保存</a-button>
        </a-space>
      </div>
    </a-card>
  </div>
</template>



<script>

import request from '@/api/request'
import CompanySelector from "@/components/company-selector";
import ProjectSelector from "@/components/project-selector";
import EmployeeSelector from "@/components/employee-selector";
function fetchDetail(id) {
  return request({
      url:  '/project-service/projectFin/detail2/' +id,
      method: 'post',
  })
}
function add(data) {
  return request({
      url:  '/project-service/sub/pay/add',
      method: 'post',
      data,
  })
}


export default {

  name: 'projectFin_detail',
  components:{
    CompanySelector,
    ProjectSelector,
    EmployeeSelector
  },
  data() {
      return {
          subProjectList: [],
          selectedCompany: {}, // 选中的公司
          selectedUser: {},
          allocateVisible: false,
          visible: false,
          loading: false,
          detail: {},
          bidList: [],
          bidBudgetList: [],

          saveLoading: false,
          finList: [],
          incomeDeptSum: [],
          expendDeptSum: [],
          type: '',
          filteredList: [],
          allProgressList: [],
          progressList: [],
          allocateList: [],
          finId: '',
          amount: 0,
          allocateOver: 0,
          ifSync: false,
          selectedProject: {
            name: ''
          }
      }
  },

  computed: {
    
  },

  mounted() {
    //查询subProjectList
  },


  methods: {
    onSelectProject(value) {
      console.log("value", value);
      this.selectedProject.name = value.name;
      this.selectedProject.id = value.id;
    },
    getList(){
      const { id } = this.$route.query;
      this.loading = true;
      fetchDetail(id).then(res => {
        if (res) {
          this.detail = res;
          this.finList = res.finList || []
          this.incomeDeptSum = res.incomeDeptSum || []
          this.expendDeptSum = res.expendDeptSum || []
          this.allProgressList = res.projectProgressList;
        }
      }).finally(() => {
        this.loading = false;
      })
    },
    handleSubmit() {

      const json = {
        ...this.detail,
        amount: this.detail.amount,
        handlerUserId: this.selectedUser.id,
        handlerUserName: this.selectedUser.name,
        projectId: this.selectedProject.id,
        companyId: this.selectedCompany.id,
        companyName: this.selectedCompany.name,
        date: this.detail.date ? this.detail.date.format("YYYY-MM-DD") : null,
      }
      add(json).then(()=>{
        console.log(111)
        this.visible = false;
        this.$close(this.$route.path);
      })
    },
    saveSuccess(value) {
      this.allocateVisible = false;
    }
  }
}
</script>

<style lang="less" scoped>
.container {
background-color: #fff;
padding: 24px 160px;
}

.card-header {
margin-top: 16px;
margin-bottom: 8px;
display: flex;
align-items: center;
justify-content: space-between;

.card-title {
font-weight: bold;
font-size: 14px;
color: #1890ff;
}


}
.sub-header{
  margin: 20px 5px 5px 5px;
}
</style>